/**
 * Writes text to the clipboard and reports whether it actually landed there.
 *
 * Two ways this fails quietly, both of which callers used to paper over:
 * `navigator.clipboard` is undefined outside a secure context, and `writeText`
 * rejects when the document isn't focused or the permission is refused. Telling
 * someone their invite link is on the clipboard when it isn't loses them the
 * link, so the result is a boolean the caller has to look at.
 */
export async function copyToClipboard(text: string): Promise<boolean> {
  if (!text || !navigator.clipboard?.writeText) return false;

  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    return false;
  }
}
